module.exports = __webpack_public_path__ + "static/media/12.docker.bbb17218.svg";